import { render, staticRenderFns } from "./WelcomeCeremonyDataTable.vue?vue&type=template&id=530961e4&scoped=true"
import script from "./WelcomeCeremonyDataTable.vue?vue&type=script&lang=js"
export * from "./WelcomeCeremonyDataTable.vue?vue&type=script&lang=js"
import style0 from "./WelcomeCeremonyDataTable.vue?vue&type=style&index=0&id=530961e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530961e4",
  null
  
)

export default component.exports